module.exports = __webpack_public_path__ + "static/media/5ed5c549458ca9ec427b1a00.722b63b8.png";